import utcToZonedTime from "date-fns-tz/utcToZonedTime";
import { format, isAfter, isEqual } from "date-fns";

export const DATE_FORMAT_DATE_INPUT = "YYYY-MM-DD";
export const DATE_FORMAT_DATE_FNS = "yyyy-MM-dd";

export const isoToDate = date => {
  return format(utcToZonedTime(new Date(date)), DATE_FORMAT_DATE_FNS);
};

export const dateToIso = date => {
  return new Date(date).toISOString();
};

export const isDateFormatValid = date => {
  if (!date) return;
  return format(new Date(date), DATE_FORMAT_DATE_FNS) === date;
};

export const currentDate = () => {
  return format(new Date(), DATE_FORMAT_DATE_FNS);
};

export const minValueForInput = dateString => {
  return dateToIso(dateString);
};

export const isDateIntervalValid = (startDate, endDate) => {
  return isAfter(new Date(endDate), new Date(startDate)) || isEqual(new Date(endDate), new Date(startDate));
};
